import { Action, Reducer } from 'redux'
import { ILaneHistory, ILaneHistoryState } from 'types/carrier'
import { LANE_HISTORY_ACTION_TYPES } from 'apps/carrier/utils/actions/laneHistory'

const {
  LANE_HISTORY_FAILURE,
  LANE_HISTORY_REQUEST,
  LANE_HISTORY_SUCCESS,
} = LANE_HISTORY_ACTION_TYPES

interface IErrorAction extends Action<string> {
  error: string
}
interface ISuccessAction extends Action<string> {
  payload: {
    laneHistory: ILaneHistory[]
    totalCount: number
  }
}

type LaneHistoryAction = Action<string> | IErrorAction | ISuccessAction

const defaultState: ILaneHistoryState = {
  firstLoad: true,
  fetching: false,
  totalCount: 0,
  lanes: [],
}

const laneHistoryReducer: Reducer<ILaneHistoryState, LaneHistoryAction> = (
  state = defaultState,
  action
) => {
  switch (action?.type) {
    case LANE_HISTORY_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: undefined,
      }
    }

    case LANE_HISTORY_SUCCESS: {
      const { laneHistory: lanes, totalCount } = (action as ISuccessAction).payload
      return {
        ...state,
        fetching: false,
        firstLoad: false,
        lanes,
        totalCount,
      }
    }

    case LANE_HISTORY_FAILURE: {
      return {
        ...state,
        fetching: false,
        firstLoad: false,
        error: (action as IErrorAction).error,
      }
    }

    default:
      return state
  }
}

export default laneHistoryReducer
